import { IconPaths, ModalSize } from '../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../components'
import { EscalaFormModal } from '../../components/EscalaFormModal'
import { useQueryResponse } from '../core/QueryResponseProvider'

export const MinhaEscalaHeader = () => {
  const { showModal } = useModal()
  const { refetch } = useQueryResponse()

  const abrirCadastro = () =>
    showModal({
      title: 'Nova escala',
      size: ModalSize.Large,
      content: <EscalaFormModal eixo='pessoal' onSuccess={refetch} />,
    })

  return (
    <div className='card-header border-0 pt-6'>
      <div className='card-title'>
        <h3 className='card-label fw-bold text-gray-800'>Minhas escalas cadastradas</h3>
      </div>
      <div className='card-toolbar'>
        <Button className='btn btn-primary' icon={IconPaths.Add} onClick={abrirCadastro}>
          Nova escala
        </Button>
      </div>
    </div>
  )
}
